import DirectorDetailsModule from './DirectorDetails.module';

export default DirectorDetailsModule;
